import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import ReactTable from "react-table"
import { connect } from "react-redux"
import { getIndustriesAction, deleteIndustryAction, FilterIndustries } from "../../actions/industriesActions"
import IndustriesTableActionsCell from "../elements/IndustriesTableActionsCell"
import DeleteModal from "../modals/DeleteModal"
import { FilterField } from "../../helpers/GeneralFillter"
import Axios from "axios"
import HandleError from "../../services/HandleError"

const IndustriesTable = ({ industries, getIndustriesAction, deleteIndustryAction, FilterIndustries}) => {
	let index = -1
	let pageNr = industries?.data?.length ? industries.meta.pagination.current_page - 1 : 0
	const totalPages = industries?.data?.length ? industries.meta.pagination.total_pages : 1
	const [showDelete, setShowDeleteModal] = useState(-1)
	const [counterPages, setCounterPages] = useState(100)

	const columns = [
		{ Header: "ID", filterable: false, accessor: "id", Cell: cellProps => cellProps.value || "" },
		{ Header: "Name", filterable: true, Filter:FilterField, accessor: "name", Cell: cellProps => cellProps.value || "" },
		{
			Header: () => <div className="header-actions">Actions</div>,
			filterable: false,
			Cell: cellProps => <IndustriesTableActionsCell
				cellProps={cellProps}
				setShowDeleteModal={setShowDeleteModal}
			/>,
		}
	]
	useEffect(()=> {
		pageNr = totalPages - 1
		const filters = industries?.filters
		getIndustriesAction({ pageSize: counterPages, sorted: null, filters, page: 1  })

		if(!industries?.data.length) {
			const filters = industries?.filters
			getIndustriesAction({ pageSize: counterPages, sorted: null, filters, page: 1  })
		}
	}, [counterPages])
	const handleCloseDelete = () => {
		setShowDeleteModal(-1)
	}

	const handlePaginateFetch = (page) => {
		const filters = industries?.filters
		getIndustriesAction({ pageSize: counterPages, sorted: null, filters, page: page + 1 });
	}

	const handleDelete = async () => {
		const { id } = industries.data[index]
		await deleteIndustryAction(id, handleCloseDelete)
	
			const filters = industries?.filters
			await getIndustriesAction({ pageSize: counterPages, sorted: null, filters, page: pageNr + 1 });

	}

	if (showDelete >= 0) {
		index = showDelete
	}

	const onRowClick = (state, rowInfo, column, instance) => {
		if(rowInfo) {
			setCounterPages(rowInfo.pageSize)
			return {
			}
			} else {
				return {}
			}	
	}	

	// filter data by serverside
	const FilterData = async (column, value) => {
		if(column.length){
			
			FilterIndustries(column[0].value); // search by name
		}else{
			FilterIndustries("")
		}
	}
	console.log("industries.data", industries?.data);
	return (
		<div className="table-style">
			<ReactTable
				data={industries?.data}
				loading={industries?.isLoading}
				columns={columns}
				defaultPageSize={15}
				pages={totalPages}
				page={pageNr}
				manual // for handle pagination
				filterable
				onFilteredChange={FilterData} 
				// defaultFilterMethod={(filter,row) => {
				// 	if(row[filter.id].toLowerCase().includes(filter.value.toLowerCase())){
				// 		return row
				// 	}
				// }}					
				showPageSizeOptions={true}
				pageSizeOptions= {[5, 10, 15, 20, 25, 50, 100]}
				sortable={false}
				className="striped-highlight remove-id unique-filter-table"
				onPageChange={handlePaginateFetch}
				getTdProps= {onRowClick}
			/>

			<DeleteModal
				isShown={showDelete !== -1}
				handleClose={handleCloseDelete}
				title={industries?.data[index] ? `Industry ${industries?.data[index].name}` : ""}
				handleDelete={handleDelete}
				isDeleting={industries?.isDeleting}
			/>
		</div>
	)
}

IndustriesTable.propTypes = {
	getIndustriesAction: PropTypes.func.isRequired,
	deleteIndustryAction: PropTypes.func.isRequired,
	industries: PropTypes.shape({
		data: PropTypes.array,
		meta: PropTypes.shape({
			pagination: PropTypes.shape({
				current_page: PropTypes.number,
				total_pages: PropTypes.number
			})
		}),
		filters: PropTypes.array,
		isLoading: PropTypes.bool,
		hasError: PropTypes.bool,
		isRestoring: PropTypes.bool,
		isDeleting: PropTypes.bool
	}).isRequired
}

const mapStateToProps = (state) => ({
	industries: state.industries
})

export default connect(mapStateToProps, { getIndustriesAction, deleteIndustryAction , FilterIndustries })(IndustriesTable)

